import { gql } from "@apollo/client";

import {
  CAMPAIGN_WITH_CALLEE_FIELDS,
  CAMPAIGN_WITH_QUESTIONS
} from "./fragments";

export const EDIT_CAMPAIGN_ALGORITHM = gql`
  ${CAMPAIGN_WITH_CALLEE_FIELDS}
  ${CAMPAIGN_WITH_QUESTIONS}
  mutation campaignEditAlgorithm(
    $campaignId: ID!
    $useAlternateDropRate: Boolean!
    $maxRatio: Int!
  ) {
    campaignEditAlgorithm(
      campaignId: $campaignId
      useAlternateDropRate: $useAlternateDropRate
      maxRatio: $maxRatio
    ) {
      ...CampaignWithCalleeFields
      ...CampaignWithQuestions
    }
  }
`;
